
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const usePreviousPath = () => {
  const location = useLocation();
  const previousPathRef = useRef<string|null>(null); 

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Update the previous path only after rendering with the new path
    previousPathRef.current = currentPath;
  }, [location.pathname]); // Effect runs when the path changes

  // Return the previous path (before the update)
  return previousPathRef.current;
};

export default usePreviousPath;

